// Test Strings
const testString1 = "n(1,2,3,4,5,6,7,8,9,10,11,12)";
const testString2 = "t(1,2,3,4,5,6,7,8,9,10,11,12)";
const testString3 = "n(1,2,3,4,5,6,7,8,9,10,11,12) + t(1,2,3,4,5,6,7,8,9,10,11,12)";
const testString4 = "(n(1,2,3,4,5,6,7,8,9,10,11,12) / 9) -45+ (1*1/1)";

// Regex for Linting
const charCheck = /^[\d,ntNT()+\-*/.\s]*$/;
const varCheck = /^([^\n]*|[nt]\(((0?[0-9]|1[0-2]),\s?)*((0?[0-9]|1[0-2]),?\s?)\))*$/;


let input = "";

var tokens = ["T", "N", "t1", "t2", "t3", "t4", "t5", "t6", "t7", "t8", "t9", "t10", "t11",
  "t12", "n1", "n2", "n3", "n4", "n5", "n6", "n7", "n8", "n9", "n10", "n11", "n12"]
var tokenReplacement = {
  "T": "\uD83C\uDF21",
  "N": "\uD83C\uDF27",
  "t1": "\u2776",
  "t2": "\u2777",
  "t3": "\u2778",
  "t4": "\u2779",
  "t5": "\u277A",
  "t6": "\u277B",
  "t7": "\u277C",
  "t8": "\u277D",
  "t9": "\u277E",
  "t10": "\u277F",
  "t11": "\u2780",
  "t12": "\u2781",
  "n1": "\uD83D\uDC04",
  "n2": "\uD83D\uDC04",
  "n3": "\uD83D\uDC04",
  "n4": "\uD83D\uDC04",
  "n5": "\uD83D\uDC04",
  "n6": "\uD83D\uDC04",
  "n7": "\uD83D\uDC04",
  "n8": "\uD83D\uDC04",
  "n9": "\uD83D\uDC04",
  "n10": "\uD83D\uDC04",
  "n11": "\uD83D\uDC04",
  "n12": "\uD83D\uDC04",
};

var tokenReplacement = {
  "T": "\uD83C\uDF21",
  "N": "\uD83C\uDF27",
  "t1": "\u2776",
  "t2": "\u2777",
  "t3": "\u2778",
  "t4": "\u2779",
  "t5": "\u277A",
  "t6": "\u277B",
  "t7": "\u277C",
  "t8": "\u277D",
  "t9": "\u277E",
  "t10": "\u277F",
  "t11": "\u2780",
  "t12": "\u2781",
  "n1": "\uD83D\uDC04",
  "n2": "\uD83D\uDC04",
  "n3": "\uD83D\uDC04",
  "n4": "\uD83D\uDC04",
  "n5": "\uD83D\uDC04",
  "n6": "\uD83D\uDC04",
  "n7": "\uD83D\uDC04",
  "n8": "\uD83D\uDC04",
  "n9": "\uD83D\uDC04",
  "n10": "\uD83D\uDC04",
  "n11": "\uD83D\uDC04",
  "n12": "\uD83D\uDC04",
};

function tokenizeInput(e){
  /*
  var output = tokens.reduce((acc, str) => {
    if (acc.includes(str)) {
      const replacement = tokenReplacement[str];
      return acc.replace(str, replacement);
    }
    return acc;
  }, e.target.value);
  e.target.value = output;
  */
}

// Checks if input contains valid values
// Checks if string can be calculated
function getActiveFilters() {
  if (!filters || !filters[currentQuestionIndex]) {
    return [];
  }
  return filters[currentQuestionIndex].filter(function(filter) {
    return filter && filter.active && filter.left && filter.right;
  });
}

function checkInputs(){
  let activeFilters = getActiveFilters();
  if (activeFilters.length === 0) {
    return true;
  }

  for(i = 0; i < activeFilters.length; i++){
    let string1 = activeFilters[i].left;
    let string2 = activeFilters[i].right;
    if(checkSyntax(string1)){
      if(testCalc(string1)){
        
      } else {
        showMessage("Filter " + (i+1) + ": linke Seite lässt sich nicht berechnen")
        return false;
      }
    } else{
      showMessage("Syntaxfehler in Filter " + (i+1) + " linke Seite")
      return false;
    }
    if(checkSyntax(string2)){
      if(testCalc(string2)){
        
      } else {
        showMessage("Filter " + (i+1) + ": rechte Seite lässt sich nicht berechnen")
        return false;
      }
    } else {
      showMessage("Syntaxfehler in Filter " + (i+1) + " rechte Seite")
      return false;
    }
  }
  return true;
}

function testCalc(str){
  let stringsToReplace = tokens
  stringsToReplace.sort((a, b) => b.length - a.length);
  
  // Replace all occurrences of each string in the array with the replacement string
  for (let i = 0; i < stringsToReplace.length; i++) {
    const regex = new RegExp(`(^|[^a-zA-Z0-9])${stringsToReplace[i]}($|[^a-zA-Z0-9])`, "g");
    str = str.replace(regex, `$1${1}$2`);
  }
  
  try {
    // Try to evaluate the string as a mathematical expression
    eval(str);
    if(eval(str) == Infinity){
      return false
    }
    return true;
  } catch (e) {
    // If an error occurs during evaluation, the string is not calculable
    return false;
  }
}

// Filters wholeClimate based on comparing the input values
function filterData(){
  filteredClimate = [];
  let activeFilters = getActiveFilters();
  if (!wholeClimate) {
    return;
  }
  if (activeFilters.length === 0) {
    filteredClimate = wholeClimate.slice();
    return;
  }

  let inputStrings = activeFilters.map(function(filter) {
    return [filter.left, filter.right];
  });
  
  for(i = 0; i < wholeClimate.length; i++){
    for(j = 0; j < inputStrings.length; j++){
      let str1 = replaceTokens(inputStrings[j][0], wholeClimate[i]);
      let str2 = replaceTokens(inputStrings[j][1], wholeClimate[i]);
      if(calcString(str1) < calcString(str2)){
        break;
      } else {
        if (j === inputStrings.length - 1){
          filteredClimate.push(wholeClimate[i])
        }
      }
    }
  }
};

// Returns the result of a given function
function calcString(fn) {
  return new Function('return ' + fn)();
}

//function testCalc(str) {
//  const regex = /[nt]\((\d{1,2}(\s*,\s*\d{1,2})*)?\)/g; // matches "n" or "t" followed by brackets containing one or more comma-separated numbers
//  strRepl = str.replace(regex, "1"); // replaces all matches with "1"
//  
//  
//}


//Checks if the right characters and variables are used
function checkSyntax(str){
    
    return charCheck.test(str)
    //return charCheck.test(str) && varCheck.test(str)
}


function replaceTokens(str, station) {
  // Escape special characters in tokens to prevent them from being interpreted as regular expressions
  const escapedTokens = tokens.map(token => token.replace(/[.*+?^${}()|[\]\\]/g, '\\$&'));
  // Create a regular expression to match any of the tokens with word boundaries and lookarounds
  //const tokenRegex = new RegExp(`(?<!\\w)(${escapedTokens.join('|')})(?!\\w)`, 'g');
  //RegExp(`\\b(${escapedTokens.join('|')})\\b`, 'g')
  const tokenRegex = new RegExp(`\\b(${escapedTokens.join('|')})\\b`, 'g')


  // Replace all matches of the regular expression with the corresponding value from wholeClimate
  const outputStr = str.replace(tokenRegex, (match, token) => station[token]);
  return outputStr;
}
